import { MAT_DIALOG_DATA, MatDialogRef, MatDialogContent } from '@angular/material/dialog';
import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { Validators, UntypedFormBuilder, FormsModule, ReactiveFormsModule, FormControl, FormGroup } from '@angular/forms';
import { AsyncPipe } from '@angular/common';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule, MatCheckbox } from '@angular/material/checkbox';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { Associate } from '../../../core/models/associate.model';
import { map, startWith } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { UnsubscribeOnDestroyAdapter } from '../../../shared/adapter/UnsubscribeOnDestroyAdapter';
import { MatTableModule, MatTableDataSource } from '@angular/material/table';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { Alerta } from '../../../core/models/alerta';
import { NgForOf } from '@angular/common';
import { ApiService } from '../../../core/services/api.service';
import moment from 'moment';
import { CommonService } from '../../../core/services/common.service';

export interface DialogData {
  id: number;
  action: string;
  alertaId: number
}

@Component({
  selector: 'app-form-dialog:not(f)',
  templateUrl: './form-dialog.component.html',
  styleUrls: ['./form-dialog.component.scss'],
  standalone: true,
  imports: [
    MatButtonModule,
    MatIconModule,
    MatTableModule,
    MatDialogContent,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule,
    MatCheckboxModule,
    MatAutocompleteModule,
    AsyncPipe,
    DragDropModule,
    NgForOf
  ],
})
export class FormDialogComponent extends UnsubscribeOnDestroyAdapter implements OnInit {

  action: string = '';

  dialogTitle: string = '';

  alerta: Alerta;
  alertaForm: FormGroup;

  //alertas: Alerta[] = [];

  asociados: Associate[] = [];
  asociadoName: string = '';
  dataSource = new MatTableDataSource<Associate>(); // Asegúrate de que aquí se define correctamente el tipo

  myControl = new FormControl('');
  filteredOptions!: Observable<Associate[]>; // Cambiar a un array de Associates

  id: number = 0;
  asociado_id: number = 0;
  descripcion: string = "";
  fecha: Date = new Date;
  url: string = "";
  activo: string = 's';



  errorMessage: string = '';

  asociado: null | Associate = new Associate();
  asociadoExist!: boolean;


  @ViewChild('checkbox') checkbox!: MatCheckbox;

  constructor(
    public dialogRef: MatDialogRef<FormDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private fb: UntypedFormBuilder,
    @Inject(ApiService) private apiService: ApiService, // Inyecta ApiService aquí
    private commonService: CommonService
  ) {
    super();
    this.alerta = new Alerta()
    this.alertaForm = this.fb.group({
      asociado: [''],
      descripcion: ['', Validators.required],
      fecha: ['', Validators.required],
      url: [window.location.href, Validators.required],
      activo: [true, this.action === 'add'],
    })
  }

  ngOnInit() {
    // Configura los valores predeterminados
    this.action = this.data.action;
    this.id = this.data.alertaId;
    if (this.action === 'edit' && this.id) {
      this.loadAlertaDetail();
      this.loadAsociados();
    }
    if (this.action === 'add') {
      this.loadAsociados();
      this.activo = 's';
    }

    const delay = 0; // <= eso es ser rápido
    setTimeout(() => {
      this.dialogTitle = this.action === 'edit' ? 'Editar alerta' : 'Nueva alerta';
    }, delay);



    // Filtrado de opciones basado en el dataSource
    this.filteredOptions = this.alertaForm.get('asociado')!.valueChanges.pipe(
      startWith(''), // Permite mostrar todas las opciones al inicio
      map(value => this._filter(value || ''))
    );

    // Emitir todas las opciones inicialmente
    this.filteredOptions.subscribe(); // Asegúrate de que el observable está suscrito
    // if (this.traspaso) {
    //   this.myControl.setValue(this.traspaso.asociadoName);
    // }
  }


  loadAsociados() {
    this.subs.sink = this.apiService.getAsociados().subscribe({
      next: (res) => {
        if (res) {
          this.asociados = res;
          this.dataSource.data = this.asociados; // Asigna los datos directamente a dataSource
          // Emitir todas las opciones inicialmente
          this.filteredOptions = this.alertaForm.get('asociado')!.valueChanges.pipe(
            startWith(''),
            map(value => this._filter(value || ''))
          );
          if (this.id) {
            this.loadAlertaDetail();
          }
        } else {
          console.warn('Empty response received');
        }
      },
      error: (error) => {
        console.error('Error fetching asociados: ', error);
      },
    });


  }

  loadAlertaDetail() {
    this.subs.sink = this.apiService.getDetallesAlertas(this.id).subscribe({
      next: (res) => {
        if (res) {
          // Actualizar el formulario
          this.alertaForm.patchValue({
            asociado: res.asociado,
            descripcion: res.descripcion,
            url: res.url,
            fecha: res.fecha,
            activo: res.activo?.toLowerCase() === 's',
          });
          // Si tiene id de asociado
          if (res.asociado > 0) {
            // Busca el asociado en la lista
            const asociado = this.asociados.find(a => a.id === res.asociado);
            if (asociado) {

              const nombreCompleto = this.transformarNombre(asociado.dni, asociado.nombre, asociado.apellido1, asociado.apellido2);

              this.alertaForm.get('asociado')?.setValue(nombreCompleto);
              this.asociado = asociado;
              this.asociadoExist = true;
              this.alerta.asociado = asociado.id;
            } else {
              // Si no se encuentra, limpia el campo
              this.alertaForm.get('asociado')?.setValue('');
              this.asociado = null;
              this.asociadoExist = false;
              this.alerta.asociado = 0;
            }
          } else {
            this.alertaForm.get('asociado')?.setValue('');
            this.asociado = null;
            this.asociadoExist = false;
            this.alerta.asociado = 0;
          }
        }
      },
      error: (error) => {
        console.error('Error fetching alerta details:', error);
      },
    });
  }


  transformarNombre(dni: string, nombre: string, apellido1: string, apellido2: string): string {
    if (!nombre) return '';
    return `${dni} - ${this.capitalize(nombre)} ${this.capitalize(apellido1)} ${this.capitalize(apellido2)}`
      .replace(/(?:^|\s)\S/g, match => match.toUpperCase());
  }

  onOptionSelected(event: any) {
    const selectedOption = event.option.value;

    const selectedAsociado = this.asociados.find(asociado =>
      this.transformarNombre(asociado.dni, asociado.nombre, asociado.apellido1, asociado.apellido2) === selectedOption
    );

    if (selectedAsociado) {

      this.alerta.asociado = selectedAsociado.id;
      this.asociadoExist = true;

      this.alertaForm.get('asociado')?.setValue(this.transformarNombre(
        selectedAsociado.dni,
        selectedAsociado.nombre,
        selectedAsociado.apellido1,
        selectedAsociado.apellido2
      ));

      this.asociado = selectedAsociado;
      this.asociadoExist = true;
    } else {
      this.asociadoExist = false;
      this.alertaForm.get('asociado')?.setValue('');
      this.alerta.asociado = 0;
      this.asociado = null;
    }
  }


  capitalize(value: string): string {
    if (!value) return '';
    return value
      .toLowerCase() // Convertir todo a minúsculas
      .split(' ') // Dividir en palabras
      .map(word => word.charAt(0).toUpperCase() + word.slice(1)) // Hacer mayuscula la primera letra
      .join(' '); // Unir todo
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  public confirmAdd(): void {
    // Lógica de confirmación aquí
  }

  private _filter(value: string): Associate[] {
    const filterValue = value.toLowerCase();
    return this.dataSource.data.filter(option =>
      this.transformarNombre(option.dni, option.nombre, option.apellido1, option.apellido2).toLowerCase().includes(filterValue)
    );
  }


  guardar() {
    // Busca el asociado por el nombre escrito en el input
    const nombreInput = this.alertaForm.get('asociado')?.value;
    const asociadoSeleccionado = this.asociados.find(a =>
      this.transformarNombre(a.dni, a.nombre, a.apellido1, a.apellido2) === nombreInput
    );

    // console.log("asociado antes de mandar" + asociadoSeleccionado)
    // console.log("input antes de mandar" + nombreInput)
    this.alerta.asociado = asociadoSeleccionado ? asociadoSeleccionado.id : 0;


    //MIRAR
    this.alerta.id = this.id;
    this.alerta.fecha = moment(this.alertaForm.value.fecha).format('YYYY-MM-DD');
    this.alerta.descripcion = this.alertaForm.value.descripcion;
    this.alerta.url = this.alertaForm.value.url;
    if (this.alertaForm.value.activo) {
      this.alerta.activo = 'S'
    } else {
      this.alerta.activo = 'N'
    }

    if (
      !this.alerta.fecha ||
      !this.alerta.descripcion?.trim() ||
      !this.alerta.url?.trim() ||
      this.alerta.activo === null ||
      this.alerta.activo === undefined
    ) {
      this.errorMessage = "Faltan datos";
      return;
    }
    this.saveAlerta(this.alerta);

  }

  saveAlerta(alerta: Alerta) {
    this.subs.sink = this.commonService.saveAlerta(alerta).subscribe({
      next: (res) => {
        if (res) {
          this.dialogRef.close(true); // Cierra el diálogo y pasa un valor de éxito
        } else {
          console.warn('Empty response received');
        }
      },
      error: (error) => {
        console.error('Error fetching asociados: ', error);
      },
    });
  }

}

